import logo2007 from "../../assets/img/historicEvents/LogoVengeance/2007.png";
import logo2008_2009 from "../../assets/img/historicEvents/LogoNOC/2008-2009.png";
import logo2010 from "../../assets/img/historicEvents/LogoNOC/2010.png";
import logo2011 from "../../assets/img/historicEvents/LogoNOC/2011.png";
import logo2012 from "../../assets/img/historicEvents/LogoNOC/2012.png";
import logo2013 from "../../assets/img/historicEvents/LogoNOC/2013.png";
import logo2014_2015 from "../../assets/img/historicEvents/LogoNOC/2014-2015.png";
import logo2023_2026 from "../../assets/img/historicEvents/LogoNOC/2023-2026.png";

export const nightOfChampionsDetail = {
  id: "night-of-champions",
  title: "Night of Champions",
  subtitle: "Explore the event editions in a dedicated event view.",
  tabs: [
    {
      id: "logos",
      label: "Editions",
      variant: "night-of-champions",
      items: [
        {
          id: "night-of-champions-2007",
          title: "Vengeance",
          description: "Night of Champions 2007",
          imgUrl: logo2007,
        },
        {
          id: "night-of-champions-2008",
          title: "Night of Champions",
          description:
            "It's a Night of Defenders, It's a Night of Challengers, It's a Night of Champions. 2008",
          imgUrl: logo2008_2009,
        },
        {
          id: "night-of-champions-2009",
          title: "Night of Champions",
          description: "Every Championship Is on the Line 2009",
          imgUrl: logo2008_2009,
        },
        {
          id: "night-of-champions-2010",
          title: "Night of Champions",
          description: "2010",
          imgUrl: logo2010,
        },
        {
          id: "night-of-champions-2011",
          title: "Night of Champions",
          description: "It's a Night You Will Never Forget 2011",
          imgUrl: logo2011,
        },
        {
          id: "night-of-champions-2012",
          title: "Night of Champions",
          description: "2012",
          imgUrl: logo2012,
        },
        {
          id: "night-of-champions-2013",
          title: "Night of Champions",
          description: "2013",
          imgUrl: logo2013,
        },
        {
          id: "night-of-champions-2014",
          title: "Night of Champions",
          description: "Rematch. Resolve. Redemption. 2014",
          imgUrl: logo2014_2015,
        },
        {
          id: "night-of-champions-2015",
          title: "Night of Champions",
          description: "2015",
          imgUrl: logo2014_2015,
        },
        {
          id: "night-of-champions-2023",
          title: "Night of Champions",
          description: "2023",
          imgUrl: logo2023_2026,
        },
        {
          id: "night-of-champions-2025",
          title: "Night of Champions",
          description: "The Last Time is Now 2025",
          imgUrl: logo2023_2026,
        },
        {
          id: "night-of-champions-2026",
          title: "Night of Champions",
          description: "Riyadh 2026",
          imgUrl: logo2023_2026,
        },
      ],
    },
  ],
};
